import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { connect } from 'react-redux';
import { FlexCol } from '@bart.sk-eshop/eshop-defaults';
import InfoBanner from '../../components/_helpers/Default/InfoBanner';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { __ } from '@bart.sk-eshop/react-i18n';
import { withRouter, WithRouterProps } from 'react-router';
import LazyLoad from 'react-lazyload';
import CartLogic, { CartContactInfo } from './CartLogic';
import {
  cartDataSelector,
  cartIsFetchingSelector,
  cartErrorSelector,
  freeDeliveryRemainingAmountSelector,
  updateCart,
  fetchCart,
  loadFreeDeliveryRemainingAmount,
  cartShowProblemsSelector,
  errorModalSelector,
} from './cartSlice';
import API, { ThenArg } from '../../services/API';
import {
  deliveryAddressesIsFetchingSelector,
  deliveryAddressesSelector,
  fetchCustomerDetails,
  fetchDeliveryAddresses,
} from '../MyAccount/myAccountSlice';
import { userSelector } from '../App/selectors';
import ToTopButton from '../../components/_helpers/Default/ToTopButton';
import { HIDE_CHAT_WIDGET_CLASS } from '../../theme/globalStyles';
import { ga4BeginCheckout } from '@bart.sk-eshop/react-online-marketing';
import { getGoogleAdsId } from '../../configureTagManager';
import { prop } from '../../utilities';
import { CART_COOKIE_ID } from './helpers';

interface Props {
  dispatch: (action: any) => void;
  children: any;
  user: any;
  userInfo: any;
  data: any;
  error: { details: { description: string } };
  deliveryAddresses: ThenArg<typeof API.getDeliveryAddresses>;
  isFetching: boolean;
  deliveryAddressesIsFetching: boolean;
  freeDeliveryRemainingAmount: number | null;
  showProblems: boolean;
}

class Cart extends React.Component<Props & WithRouterProps> {
  public static async getInitialProps(props) {
    const { dispatch, cookies } = props;
    try {
      const cartCookie = prop(cookies, `${CART_COOKIE_ID}`);
      if (props.user) {
        await Promise.all([
          dispatch(fetchDeliveryAddresses()),
          dispatch(fetchCustomerDetails(true)),
        ]);
      }
      await Promise.all([
        dispatch(fetchCart(true, cartCookie)),
        dispatch(loadFreeDeliveryRemainingAmount()),
      ]);
      return;
    } catch (exp) {
      console.log(exp);
      return;
    }
  }

  componentDidMount() {
    const { pathname } = this.props.location;
    const data = this.props.data;

    document.body.classList.add(HIDE_CHAT_WIDGET_CLASS);

    if (pathname === '/kosik') {
      if (window.gtag) {
        if (data) {
          //  @ts-ignore
          let gData = data.items.filter(d => !d.isFromSale);
          const currency = prop(data, 'currency', 'EUR');
          ga4BeginCheckout(gData, getGoogleAdsId(), currency);
        }
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(HIDE_CHAT_WIDGET_CLASS);
  }

  public render() {
    const {
      children,
      data,
      error,
      deliveryAddresses,
      isFetching,
      deliveryAddressesIsFetching,
      dispatch,
      freeDeliveryRemainingAmount,
      showProblems,
      userInfo,
    } = this.props;

    return (
      <>
        <CartLogic
          key={1}
          handleAcceptTermsChange={this.handleAcceptTermsChange}
          handleAcceptHeurekaChange={this.handleAcceptHeurekaChange}
          handleAcceptNewsLetterChange={this.handleAcceptNewsLetterChange}
          createOrder={this.createOrder}
          dispatch={dispatch}
          data={data}
          isFetching={isFetching}
          error={error}
          deliveryAddresses={deliveryAddresses}
          deliveryAddressesIsFetching={deliveryAddressesIsFetching}
          freeDeliveryRemainingAmount={freeDeliveryRemainingAmount}
          showProblems={showProblems}
          userInfo={userInfo}
          handleUsePointsChange={this.handleUsePointsChange}
        >
          {children}
        </CartLogic>
        <ToTopButton />
      </>
    );
  }

  private handleAcceptTermsChange = e => {
    this.props.dispatch(
      updateCart({ ...this.props.data, terms_accept: e.target.value }),
    );
  };

  private handleAcceptHeurekaChange = e => {
    this.props.dispatch(
      updateCart({ ...this.props.data, heureka: e.target.value }),
    );
  };

  private handleAcceptNewsLetterChange = e => {
    this.props.dispatch(
      updateCart({ ...this.props.data, newsletter_accept: e.target.value }),
    );
  };

  private handleUsePointsChange = e => {};

  private createOrder = async (
    cartContactInfo: CartContactInfo,
  ): Promise<string> => {
    let orderPublicId = '';

    try {
      const res = await API.createOrder(
        this.props.data.id,
        {},
        {
          ...this.props.data,
          step: 3,
          ...cartContactInfo,
          delivery_address: {
            ...cartContactInfo.delivery_address,
            person: {
              ...cartContactInfo.delivery_address.person,
              email: cartContactInfo.billing_address.person.email,
            },
          },
          company: cartContactInfo.billing_company
            ? cartContactInfo.company
            : {
                dic: '',
                ic_dph: '',
                ico: '',
                name: '',
              },
        },
      );
      orderPublicId = res.orderPublicId;
    } catch (err) {
      console.log({ err });
    }

    return orderPublicId;
  };
}

const mapStateToProps = state => {
  return {
    user: userSelector(state),
    userInfo: state.myAccount.userInfo,
    data: cartDataSelector(state),
    freeDeliveryRemainingAmount: freeDeliveryRemainingAmountSelector(state),
    isFetching: cartIsFetchingSelector(state),
    error: cartErrorSelector(state),
    deliveryAddresses: deliveryAddressesSelector(state),
    deliveryAddressesIsFetching: deliveryAddressesIsFetchingSelector(state),
    showProblems: cartShowProblemsSelector(state),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'Cart' })(withRouter(Cart)),
);
